// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3_vZA","title":"header_title__KjB3w"};